import React from "react";
import { defaulatAuthContext } from "./IAuthContext";


export const AuthContext = React.createContext(defaulatAuthContext);